import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#222',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
    //   light: '#0066ff',
      main: '#008486',
    //   // dark: will be calculated from palette.secondary.main,
    //   contrastText: '#ffcc00',
    },
    // // Used by `getContrastText()` to maximize the contrast between
    // // the background and the text.
    // contrastThreshold: 3,
    // // Used by the functions below to shift a color's luminance by approximately
    // // two indexes within its tonal palette.
    // // E.g., shift from Red 500 to Red 300 or Red 700.
    // tonalOffset: 0.2,
  },
  overrides: {
    MuiInput: {
      input: {
        fieldset: {
          borderRadius: 30,
        }
      },
    },
    MuiInputLabel: { // Name of the component ⚛️ / style sheet
      outlined: { // Name of the rule
        top: 0,
        color: '#222',
        "&$focused": { // increase the specificity for the pseudo class
          color: '#222',
        },
        '&$shrink': {
          background: '#fff',
          // top: -7,
          padding: '5px 7px'
         },
      }
    },
    MuiOutlinedInput: {
      root: {
        position: 'relative',
        '& $notchedOutline': {
            borderColor: '#949494',
            borderWidth: 2,
            borderRadius: 30,
            overflow: 'hidden'
        },
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            borderColor: '#ffc10d',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderColor: '#949494',
            },
        },
        '&$focused $notchedOutline': {
            borderColor: '#ffc10d',
            borderWidth: 3,
        },
      },
    },
  },
})

export default theme